import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PopupService } from '../core/services/popup.service';
import { DocPopupTypes } from '../core/models/dialog.models';

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuard implements CanActivate {
  constructor(
    private popupService: PopupService, 
    private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     const role = localStorage.getItem('role');

    if (role === 'Admin') {
      return true; 
    }

    this.popupService.openDialog({
      type: DocPopupTypes.error,
      message: "Please login with admin credentials",
      heading: 'Invalid Login',
      buttonText: 'Ok',
    });

    setTimeout(() => {
      this.router.navigate(['/auth/admin-login']);
    }, 1000);

    
    return false;
  }
  
}
